import commonStatusReducer, { setEditorSave, setTriggerResize, setDeleteTriggerResize } from './Reducer';
import { COMMONSTATUS_REDUCER_NAME } from './Constants';

export { setEditorSave, setTriggerResize, COMMONSTATUS_REDUCER_NAME, setDeleteTriggerResize };

export default commonStatusReducer;
